import {_escape} from "../../utils/escape";
import doSearch from "../../utils/search";

const actions = {
    setParamsFromURL({commit, dispatch}, payload) {
        commit('setSearchQuery', payload.params.query);

        dispatch('doSearch');
    },

    setYearRange({commit, dispatch}, payload) {
        commit('setYearRange', payload);
        dispatch('doSearch');
    },

    loadMore({commit, state}) {
        commit('setPagination', state.currentPage + 1);
    },

    doSearch({commit, state}) {
        commit('toggleLoadingState', true);

        const filters = []

        state.facets.forEach(group => {
            group.facets.forEach((facet) => {
                if (state.activeFacets.indexOf(facet.id) !== -1) {
                    filters.push([`"${_escape(group.group)}":"${_escape(facet.name)}"`]);
                }
            });
        });

        const range = {
            min: state.yearRange.min > 0 && state.yearRange.min !== state.yearRange._min ? state.yearRange.min : false,
            max: state.yearRange.max > 0 && state.yearRange.max !== state.yearRange._max ? state.yearRange.max : false,
        }

        return doSearch(state.query, filters, range, state.currentPage).then(data => {
            commit('doSearch', data);
            commit('setPaginationVisibility', data._meta.page < data._meta.nbPages);
        }).finally(() => {
            commit('toggleLoadingState', false);
        });
    },

    setSearchQuery({commit, dispatch}, query) {
        commit('setSearchQuery', query);
        dispatch('doSearch');
    },

    setResults({commit}, results) {
        commit('setResults', results);
    },

    toggleFacet({commit, dispatch}, {id, exclusive}) {
        commit('setLoadingOnFacet', id);
        commit('toggleFacet', {id, exclusive});

        dispatch('doSearch');
    },

    resetFacets({commit}) {
        return commit('resetFacets');
    },

    toggleLoadingState({commit}, loading = false) {
        commit('toggleLoadingState', loading);
    },

    resetSearch({commit, dispatch}) {
        commit('resetFacets');
        commit('setSearchQuery', '');
        dispatch('doSearch');
    }
};


export default actions;